<script lang="ts" setup>
import ListItem from './PageHeaderListItem.vue';
import ResourceTools from './ResourceTools.vue';
</script>

<template>
  <ul class="m-0 flex list-none justify-between px-0 py-32 <lg:flex-col <lg:gap-32 <lg:py-16">
    <li class="flex flex-col gap-y-16">
      <div class="text-14 color-#A1A1A1 font-400 leading-17">{{ $t('header.cooperation.content1.title') }}</div>
      <ul class="m-0 w-331 list-none p-0">
        <li>
          <ListItem :title="$t('header.cooperation.content1.item1.title')" :description="$t('header.cooperation.content1.item1.desc')" to="/cooperation/financial">
            <template #icon>
              <img data-src="@/home/assets/header/cooperation-1.svg" alt="" class="lazyload size-24">
            </template>
          </ListItem>
        </li>
        <li>
          <ListItem :title="$t('header.cooperation.content1.item2.title')" :description="$t('header.cooperation.content1.item2.desc')" to="/cooperation/project">
            <template #icon>
              <img data-src="@/home/assets/header/cooperation-2.svg" alt="" class="lazyload size-24">
            </template>
          </ListItem>
        </li>
        <li>
          <ListItem :title="$t('header.cooperation.content1.item3.title')" :description="$t('header.cooperation.content1.item3.desc')" to="/cooperation/partner">
            <template #icon>
              <img data-src="@/home/assets/header/cooperation-3.svg" alt="" class="lazyload size-24">
            </template>
          </ListItem>
        </li>
      </ul>
    </li>

    <li class="flex flex-col gap-y-16">
      <div class="text-14 color-#A1A1A1 font-400 leading-17">{{ $t('header.cooperation.content2.title') }}</div>
      <ul class="m-0 w-331 list-none p-0">
        <li>
          <ListItem :title="$t('header.cooperation.content2.item1.title')" :description="$t('header.cooperation.content2.item1.desc')" to="/cooperation">
            <template #icon>
              <img data-src="@/home/assets/header/cooperation-4.svg" alt="" class="lazyload size-24 object-contain">
            </template>
          </ListItem>
        </li>
        <li>
          <ListItem :title="$t('header.cooperation.content2.item2.title')" :description="$t('header.cooperation.content2.item2.desc')" href="https://atomgit.com/OpenAtomFoundation/Projects/blob/master/ProjectContribution.md">
            <template #icon>
              <img data-src="@/home/assets/header/cooperation-5.svg" alt="" class="lazyload size-24 object-contain">
            </template>
          </ListItem>
        </li>
        <!-- <li>
          <ListItem :title="$t('header.cooperation.content2.item3.title')" :description="$t('header.cooperation.content2.item3.desc')" href="#">
            <template #icon>
              <img data-src="@/home/assets/header/cooperation-6.svg" alt="" class="lazyload size-24 object-contain">
            </template>
          </ListItem>
        </li>
        <li>
          <ListItem :title="$t('header.cooperation.content2.item4.title')" href="#">
            <template #icon>
              <img data-src="@/home/assets/header/cooperation-7.svg" alt="" class="lazyload size-24 object-contain">
            </template>
          </ListItem>
        </li> -->
      </ul>
    </li>

    <ResourceTools />
  </ul>
</template>
